<template>
  <div class="footer_warp">
    <div class="footer_main">
      <el-image style="width: 130px; height: auto;" :src="require('../../assets/image/logo.png')"></el-image>
      <div class="middle">
        <div>CopyRight 2023 All Rights Reserved</div>
        <div class="line"></div>
        <div>鲁ICP备202102767号</div>
      </div>
      <div class="bottom">
        <div>山东喻白信息技术有限公司</div>
        <div class="phone">电话：0531-88984637</div>
        <div>地址：山东省济南市历下区舜华街道舜义路77号碧桂园凤凰中心B座2534</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    init(){

    }
  }
}
</script>

<style lang="scss" scoped>
.footer_warp{
  width: 100%;
  .footer_main{
    width: 100%;
    height: 150px;
    font-size: 0;
    background: #1B1D1F;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .middle{
      font-size: 12px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 10px;
      .line{
        width: 1px;
        height: 14px;
        background: #ffffff;
        margin: 0 10px;
      }
    }
    .bottom{
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      .phone{
        margin: 0 20px;
      }
    }
  }
}
</style>
